import * as ExcelJS from 'exceljs';
import { addNumberFormatting, addWorkSheetInfo, createSingleOptionWorksheets, createWorkbook, createWorksheet, exportWorkbook, setColumnWidths, simpleCustomFieldsMasterProps, styleColumns } from '../helperTemplateExcel';
import { CustomField, SettingMultiMeetings, SettingMultiMerchants } from '../../../interfaces/Settings';
import { MultiSimplePipeline } from '../../../interfaces/Pipeline';
import { MultiSimpleMeeting } from '../../../interfaces/Meeting';
import { Merchant, MultiSimpleMerchant, SimpleMerchant } from '../../../interfaces/Merchant';
import { User } from '../../../interfaces/User';
import { UserModel } from '../../../app/modules/auth/models/UserModel';
import { addSingleOptionValidation, getCellNote, getCellNoteLocation, getCustomFieldFilteredMeeting } from '../functionHelperExcel';
import { Label } from '../../../interfaces/Label';
import { formatSubHeader } from '../../../hooks/NameColumnExcel';
import { UserCompany } from '../../../interfaces/UserCompany';

interface ExportTemplateVisitMeetingExcelProps {
    nameFile: string,
    customFields: CustomField,
    source: string,
    typeAction: string,
    settings: any,
    nameInfo: string,
    nameHeader: any,
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
    simpleCustomFieldsMaster: simpleCustomFieldsMasterProps,
    user: UserModel,
    param: any,
    dataMerchants: SimpleMerchant[],
    intl: any,
    selectMultiMeeting: SettingMultiMeetings
    multiMerchants: SettingMultiMerchants[]
    merchants: Merchant[]
    titleMerchants: string
    dataLabel: Label[],
    users: User[],
    usersCompany: UserCompany[],
    type?: string,
    templateMeetingId: string,
    multiMeetings: SettingMultiMeetings[]
}

export const exportTemplateVisitMeeting = async ({ nameFile, customFields, source, typeAction, settings, nameInfo, nameHeader, setIsLoading, simpleCustomFieldsMaster, user, param, dataMerchants, intl, selectMultiMeeting, multiMerchants, merchants, titleMerchants, dataLabel, users, usersCompany, type, templateMeetingId, multiMeetings }: ExportTemplateVisitMeetingExcelProps) => {
    let exportData: any[] = [];
    const workbook = createWorkbook();
    const worksheet = createWorksheet(workbook, "Sheet1");
    const worksheetInfo = createWorksheet(workbook, "Info");
    var header: string[] = []
    var subHeader: string[] = []

    const filteredCustomFieldMeeting = getCustomFieldFilteredMeeting(templateMeetingId as string, multiMeetings)

    header = [...nameHeader.insert.meeting.originalMeeting.header, ...nameHeader.insert.meeting.visitMeeting.header,
    ...Object.keys(filteredCustomFieldMeeting).map((field: any) => filteredCustomFieldMeeting[field].name),

    ];
    subHeader = [...nameHeader.insert.meeting.originalMeeting.subHeader, ...nameHeader.insert.meeting.visitMeeting.subHeader,
    ...Object.keys(filteredCustomFieldMeeting).map((field: any) => formatSubHeader(field, filteredCustomFieldMeeting, intl))
    ];

    let worksheetPic = workbook.addWorksheet(`Daftar PIC`);
    await worksheetPic.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetPic.getCell('A1').value = `Daftar PIC`;
    await param?.dataUsers?.forEach((user: any) => {
        worksheetPic.addRow([user.name]);
    });

    let worksheetMerchant = workbook.addWorksheet(`Daftar ${settings.merchant_title}`);
    await worksheetMerchant.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetMerchant.getCell('A1').value = `Daftar ${settings.merchant_title}`;
    await dataMerchants?.forEach((merchant: any) => {
        worksheetMerchant.addRow([merchant.name]);
    });

    let worksheetLabel = workbook.addWorksheet('Daftar Label');
    worksheetLabel.getCell('A1').value = `Daftar Label`;
    await dataLabel?.forEach((label: any) => {
        worksheetLabel.addRow([label.name]);
    });

    // Daftar Single Option
    const singleOptionSheetsMeeting = createSingleOptionWorksheets({ customFields, workbook, simpleCustomFieldsMaster, user: user, intl, source, selectMultiMeeting, multiMerchants, merchants });

    if (type === 'error') {
        header.push('Error');
        subHeader.push('Abaikan kolom ini');
        Array.from(param.listErrorInsert).map((row: any, index) => {
            var temp_excel = [];
            temp_excel.push(
                row.pic_name,
                row.merchant_name,
                row.label_name,
                row.locationString,
                row.note,
                row.attachments,
                ...Object.keys(customFields).map((field: any) => row[field]),
                row.error
            );

            exportData.push(temp_excel);
        });
    }

    worksheet.getRow(1).values = header;
    worksheet.getRow(2).values = subHeader;
    setColumnWidths(worksheet, source, header!);
    styleColumns(worksheet, source, 1);
    styleColumns(worksheet, source, 2);
    addDataRows(worksheet, exportData, customFields, source, type!, typeAction, user!, dataMerchants, dataLabel, users, usersCompany, param, singleOptionSheetsMeeting, simpleCustomFieldsMaster, settings.merchant_title);
    addWorkSheetInfo(worksheetInfo, source, nameFile, nameInfo, nameHeader, user!);

    exportWorkbook(workbook, `${nameFile}.xlsx`, setIsLoading);
}

const addDataRows = (
    worksheet: ExcelJS.Worksheet,
    data: any[],
    customFields: CustomField,
    source: string,
    type: string,
    typeAction: string,
    user: UserModel,
    dataMerchants: SimpleMerchant[],
    dataLabel: Label[],
    users: User[],
    usersCompany: UserCompany[],
    param?: any,
    singleOptionSheets?: any,
    simpleCustomFieldsMaster?: {
        pipelines: MultiSimplePipeline
        meetings: MultiSimpleMeeting
        merchants: MultiSimpleMerchant
    },
    titleMerchant?: string
) => {
    data.forEach((rowData, index) => {
        worksheet.addRow(rowData);
    });

    for (let i = 3; i <= 3; i++) {
        const cellLabel = worksheet.getCell(`C` + i);
        cellLabel.note = getCellNote('Daftar Label');
        worksheet.getCell('D' + i).note = getCellNoteLocation();
    }

    for (let i = 3; i < 550; i++) {
        if (typeAction === 'insert') {
            worksheet.getCell('A' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar PIC'!$A$2:$A$${users.length + 1}`],
                errorStyle: 'error',
                error: 'Pilih PIC',
            };
            worksheet.getCell('B' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar ${titleMerchant}'!$A$2:$A$${dataMerchants.length + 1}`],
                errorStyle: 'error',
                error: 'Pilih merchant',
            };
            addSingleOptionValidation('G', customFields, singleOptionSheets, typeAction, type, param, worksheet, simpleCustomFieldsMaster);
            addNumberFormatting('G', customFields, typeAction, type, param, worksheet);
        }
    }
};